import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '@app/core/session/session.service';
import { map } from 'rxjs/operators';
import { MEMBER_PAGE_PATH } from '@app/consts';
import { BaseParamsService } from '@app/core/base-params.service';
import { PermanentStorageService } from '@app/core/permanent-storage.service';

export const authCallbackGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const activatedRoute = inject(ActivatedRoute);
  const sessionService = inject(SessionService);
  const baseParamsService = inject(BaseParamsService);
  const storage = inject(PermanentStorageService);

  return sessionService.isBasicallyAuthenticated()
    .pipe(
      map(authenticated => {
        if (!authenticated) {
          return router.parseUrl(baseParamsService.getRootURI());
        }
        const redirectUrl = storage.popLoginRedirectUrl();
        if (redirectUrl) {
          return router.parseUrl(redirectUrl);
        }
        return router.createUrlTree(['.', MEMBER_PAGE_PATH], { relativeTo: activatedRoute });
      }),
    );
};
